import { render, staticRenderFns } from "./ShiftReport.vue?vue&type=template&id=36f8dae5&scoped=true"
import script from "./ShiftReport.vue?vue&type=script&lang=ts"
export * from "./ShiftReport.vue?vue&type=script&lang=ts"
import style0 from "./ShiftReport.vue?vue&type=style&index=0&id=36f8dae5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f8dae5",
  null
  
)

export default component.exports